import { useGetAssessmentProgresses } from "@/api/console/assessment-progresses/useGetAssessmentProgresses";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { InputWithIcon } from "@/components/ui/input";
import { STATUS } from "@/config/progress";
import SubmissionTable from "@/src/console/(auth)/(check-assessments)/check-submissions/_components/SubmissionTable";
import { BuildingRegular } from "@fluentui/react-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function CheckSubmissions() {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      name: t("check-submissions"),
      href: "/console/check-submissions",
    },
  ];
  const [search, setSearch] = useState("");
  const statuses = [
    STATUS.SUBMITTED,
    STATUS.ASSESSMENT_GRADED_COMPLETED,
    STATUS.ASSESSMENT_EVALUATION_COMPLETED,
    STATUS.IMPROVEMENT_PROPOSAL_COMPLETED,
  ];
  const { data, isLoading } = useGetAssessmentProgresses(statuses.join(","));
  const submissions = data?.data ?? [];
  const searchedSubmissions = submissions.filter((submission) =>
    (submission.company_name ?? "")
      .toLowerCase()
      .includes(search.toLowerCase()),
  );

  return (
    <div>
      <div className="bg-white shadow">
        <AdminNavbar breadcrumbs={breadcrumbs} />
        <div className="my-heading px-6 pt-8">{t("check-submissions")}</div>
        <div className="flex justify-between px-6 pb-6 pt-8">
          <InputWithIcon
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            Icon={BuildingRegular}
            placeholder="Search"
          />
        </div>
      </div>
      <div className="m-6">
        <SubmissionTable data={searchedSubmissions} isLoading={isLoading} />
      </div>
    </div>
  );
}

export default CheckSubmissions;
